var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('van-row',[_c('van-col',{attrs:{"span":"6"}},[_c('div',{attrs:{"id":"logo"}},[_c('img',{attrs:{"src":require("../assets/logo.png")}})])]),_vm._v(" "),_c('van-col',{attrs:{"span":"18"}},[_c('div',{attrs:{"id":"header-info"}},[_vm._v("\n        "+_vm._s(_vm.headerText)+"\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3adb820d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VHeader.vue
// module id = null
// module chunks = 